<template>
  <div>
    <div class="content-header">
      <div class="clearfix">
        <h1 class="header-form-loan-info text-uppercase mb-4 float-left">{{ $t('anSetting')}}</h1>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>{{$t('stName')}}</th>
                      <th>{{$t('stValue')}}</th>
                      <th>{{$t('stAction')}}</th>
                    </tr>
                  </thead>
                  <tbody class="body-loan-table">
                    <tr v-for="setting in settings" :key="setting._id">
                      <td>{{ setting.name }}</td>
                      <td v-if="setting.value">
                        {{ setting.value | displayAmount }}
                      </td>
                      <td v-if="setting.metadata">
                        <p>{{$t('stTimeperiod')}} : {{ setting.metadata.timePeriod }} {{ $t('table.year')}}</p>
                        <p>{{$t('stKurs')}} : {{ setting.metadata.currency }}</p>
                        <p>{{$t('stInterest')}}: {{ setting.metadata.interest }} %</p>
                      </td>
                      <td>
                        <router-link :to="{name: 'adminSettingUpdate', params: {id: setting._id, setting: setting}}">{{ $t('table.edit')}}</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSetting",
  data() {
    return {
      settings: []
    };
  },
  mounted() {
    this.$axios.get("/admin/v1/priority/settings")
    .then(res => {
      this.settings = res.data.data;
    })
    .catch(function(err) {
      console.log(err)
    });
  }
};
</script>